import { v3FiltersFormat } from "@redotech/redo-support-common/conversation-filters/conversation-filter-formats";
import { View } from "@redotech/redo-support-common/view";
import { CreateViewBody } from "@redotech/redo-views-common/create-view-body";
import { RedoAdminClient } from "../../../client";
import { createView } from "../../../client/team";

export async function setupViews({
  client,
  signal,
  views,
  teamId,
}: {
  teamId: string;
  views: View[];
  client: RedoAdminClient;
  signal?: AbortSignal;
}) {
  const viewsToCreate: CreateViewBody[] = views.map((view) => {
    return {
      name: view.name,
      filters: v3FiltersFormat.write(view.filters),
      isPrivate: false,
    };
  });
  await Promise.all(
    viewsToCreate.map((view) => createView(client, teamId, view, signal)),
  );
}
